import styled from "styled-components";

export const ContainerInfo = styled.div`

    display: flex;
    flex-direction: column;

    padding: 8px 12px;
    padding-right: 20px;
    gap: 2px;
    background-color: #F8F9F9;
    color: #4d5a5e;
    border-radius: 4px;
    font-size: 12px;
    margin-top: 16px;
    border: 1px solid rgb(216, 220, 222);
    font-weight: 400;

    p, svg{
        color: #293239;
    }

    span{
        margin-left: 20px;
        color: #5C6970;
    }

    .title{
        display: flex;
        gap: 4px;
    }
`